import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { useSelector } from 'react-redux';

import Swal from 'sweetalert2';
import { Button, Container, Card, Row, Col, Form, InputGroup } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import moment from 'moment';

import { createPopup, uploadPopupImage } from 'apis/admin/pageApi';

import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ReactDatePicker from 'components/DatePicker/ReactDatePicker';
import PopUp from 'components/PopUp/PreviewPopUp';

function CreatePopup(props) {
  const user = useSelector(state => state.user);

  const [imageData, setImageData] = useState();           // 팝업 내용(content)의 이미지를 담는 state
  const [startDateState, setStartDateState] = useState(); // 팝업 시작 일시
  const [endDateState, setEndDateState] = useState();     // 팝업 종료 일시

  const [showPreview, setShowPreview] = useState(false);  // 미리보기 모달 여닫는 state

  // react-hook-form
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors, isSubmitted },
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onSubmit',
  });

  // react-hook-form에 기본값 세팅(default value)
  useEffect(() => {
    setValue('is_center', 1);
    setValue('activated', 1);
  }, []);

  // 선택한 이미지를 state에 저장
  const storeImage = (event) => {
    setImageData(event.target.files[0]);
  };

  // 사용자가 업로드한 이미지 삭제
  const deleteUploaded = () => {
    let fileElement = document.querySelector('input[type="file"].form-control-file');
    fileElement.value = '';
    setImageData();
  };

  // 저장 전 이미지 업로드
  const imageUpload = async () => {
    const formData = new FormData();
    formData.append('image', imageData);

    let result;
    await uploadPopupImage(formData)
      .then(response => {
        if (response.data.success) {
          result = response.data.result.replace(/\\/g, '/');
        }
      })
      .catch(error => {
        console.error('error occured in Page/Popup/CreatePopup.js - imageUpload() ', error);

        Swal.fire({
          icon: 'error',
          title: '팝업 내용(이미지)을 저장할 수 없습니다.',
          text: '잠시 후 다시 시도해주세요.',
        }).then(() => {
          return;
        });
      });

    return result;
  };

  // 팝업 추가
  const onSubmit = async (data) => {
    if (isSubmitted) {
      return;
    }
    
    let dataToSubmit = {};
    for (const key in data) {
      if (Number.isNaN(data[key])) {
        continue;
      }
      if (key === 'width' || key === 'height' || key === 'left' || key === 'top' || key === 'disable_hours') {
        if (data[key] === '') {
          dataToSubmit[key] = null;
          continue;
        }
      }
      dataToSubmit[key] = data[key];
    }
    dataToSubmit.content = '';
    if (startDateState) {
      dataToSubmit.start_date = String(moment(startDateState).format('YYYY-MM-DD'));
    }
    if (endDateState) {
      dataToSubmit.end_date = String(moment(endDateState).format('YYYY-MM-DD'));
    }
    dataToSubmit.mem_id = user.userData.id;

    const imageContent = await imageUpload();
    dataToSubmit.content = imageContent;

    if (dataToSubmit.content !== '') {
      await createPopup(dataToSubmit)
        .then((response) => {
          if (response.data.success) {
            Swal.fire({
              icon: 'success',
              title: '팝업 추가를 완료했습니다.',
            }).then(() => {
              props.history.push('/admin/pages/popup/list');
            });
          }
          else {
            Swal.fire({
              icon: 'error',
              title: '팝업을 추가할 수 없습니다.',
              text: '잠시 후 다시 시도해주세요.',
            }).then(() => {
              return;
            });
          }
        })
        .catch(error => {
          console.error('error occured in Page/Popup/CreatePopup.js - onSubmit() ', error);
  
          Swal.fire({
            icon: 'error',
            title: '팝업을 추가할 수 없습니다.',
            text: '잠시 후 다시 시도해주세요.',
          }).then(() => {
            return;
          });
        });
    }
  };

  return (
    <div>
      <SimpleHeader parentName="페이지 설정" name="팝업 관리 - 추가" />
      <Container className="mt--6" fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <div className="pl-lg-4 pr-lg-4 pt-4">
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        제목
                      </Form.Label>
                      <Col>
                        <Form.Control type="text" {...register('title')} />
                        <Form.Text muted>
                          구분을 위한 제목으로, 관리자 페이지에서만 보입니다.
                        </Form.Text>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        시작일
                      </Form.Label>
                      <Col sm={4}>
                        <ReactDatePicker myDate={startDateState} setMyDate={setStartDateState} minDate={new Date(moment())} />
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        종료일
                      </Form.Label>
                      <Col sm={4}>
                        <ReactDatePicker myDate={endDateState} setMyDate={setEndDateState} />
                      </Col>
                    </Form.Group>
                    {/* <fieldset>
                      <Form.Group as={Row}>
                        <Form.Label
                          as="legend"
                          column
                          sm={2}
                          className="text-sm"
                        >
                          팝업 정렬
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Check
                            type="radio"
                            label="가운데 정렬"
                            className="text-sm is-center-radio"
                            name="iscenter"
                            id="iscenter"
                            inline
                            defaultChecked
                            value={1}
                            onClick={() => setValue('is_center', 1)}
                          />
                          <Form.Check
                            type="radio"
                            label="좌측 정렬"
                            className="text-sm is-center-radio"
                            name="iscenter"
                            id="isleft"
                            inline
                            value={0}
                            onClick={() => setValue('is_center', 0)}
                          />
                        </Col>
                      </Form.Group>
                    </fieldset>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        좌측 위치
                      </Form.Label>
                      <Col sm={4}>
                        <InputGroup className="mb-2">
                          <Form.Control type="number" {...register('left')} />
                          <InputGroup.Append>
                            <InputGroup.Text className="border-0 pr-0 text-sm text-default">
                              px
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                        <Form.Text muted>
                          좌측으로부터 얼마 만큼 여백이 생기게 할 것인지를
                          결정합니다. (좌측 정렬로 선택 시)
                        </Form.Text>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        상단 위치
                      </Form.Label>
                      <Col sm={4}>
                        <InputGroup className="mb-2">
                          <Form.Control type="number" {...register('top')} />
                          <InputGroup.Append>
                            <InputGroup.Text className="border-0 pr-0 text-sm text-default">
                              px
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Col>
                    </Form.Group> */}
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        팝업 크기
                      </Form.Label>
                      <Col sm={2}>
                        <InputGroup className="mb-2">
                          <InputGroup.Prepend>
                            <InputGroup.Text className="border-0 pl-0 text-sm text-default">
                              너비
                            </InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control type="number" {...register('width')} />
                          <InputGroup.Append>
                            <InputGroup.Text className="border-0 pr-0 text-sm text-default">
                              px
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Col>
                      <Col sm={2}>
                        <InputGroup className="mb-2">
                          <InputGroup.Prepend>
                            <InputGroup.Text className="border-0 pl-0 text-sm text-default">
                              높이
                            </InputGroup.Text>
                          </InputGroup.Prepend>
                          <Form.Control type="number" {...register('height')} />
                          <InputGroup.Append>
                            <InputGroup.Text className="border-0 pr-0 text-sm text-default">
                              px
                            </InputGroup.Text>
                          </InputGroup.Append>
                        </InputGroup>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        팝업 표시 기기
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          as="select"
                          custom
                          {...register('device')}
                        >
                          <option
                            value="all"
                            onChange={() => setValue('device', 'all')}
                          >
                            모든 기기
                          </option>
                          <option
                            value="pc"
                            onChange={() => setValue('device', 'pc')}
                          >
                            PC
                          </option>
                          <option
                            value="mobile"
                            onChange={() => setValue('device', 'mobile')}
                          >
                            모바일
                          </option>
                        </Form.Control>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        팝업 표시 페이지
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control as="select" custom {...register('page')}>
                          <option
                            value="1"
                            onChange={() => setValue('page', 1)}
                          >
                            메인 페이지에서만
                          </option>
                          <option
                            value="2"
                            onChange={() => setValue('page', 2)}
                          >
                            모든 페이지
                          </option>
                        </Form.Control>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        팝업 링크
                      </Form.Label>
                      <Col>
                        <Form.Control type="text" {...register('link')} />
                        <Form.Text muted>
                          팝업을 클릭하면 이동하고자 하는 웹페이지의 링크를 사용하세요.
                        </Form.Text>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        팝업 닫기 지속 시간
                      </Form.Label>
                      <Col sm={4}>
                        <Form.Control
                          type="number"
                          defaultValue={24}
                          {...register('disable_hours', {
                            valueAsNumber:
                              '1 이상 48 이하의 숫자만 입력 가능합니다.',
                            min: {
                              value: 1,
                              message:
                                '1 이상 48 이하의 숫자만 입력 가능합니다.',
                            },
                            max: {
                              value: 48,
                              message:
                                '1 이상 48 이하의 숫자만 입력 가능합니다.',
                            },
                          })}
                          isInvalid={errors.disable_hours}
                        />
                        <Form.Text muted>
                          사용자가 팝업에 있는 닫기 버튼을 클릭시 쿠키 적용
                          시간.
                          <br />
                          해당 시간 동안 팝업이 보이지 않습니다.
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">
                          {errors.disable_hours && errors.disable_hours.message}
                        </Form.Control.Feedback>
                      </Col>
                    </Form.Group>
                    <fieldset>
                      <Form.Group as={Row} className="align-items-center">
                        <Form.Label
                          as="legend"
                          column
                          sm={2}
                          className="text-sm"
                        >
                          활성화 여부
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Check
                            type="radio"
                            label="활성화"
                            className="text-sm activated-radio"
                            name="activated"
                            id="activated"
                            inline
                            defaultChecked
                            value={1}
                            onClick={() => setValue('activated', 1)}
                          />
                          <Form.Check
                            type="radio"
                            label="비활성화"
                            className="text-sm activated-radio"
                            name="activated"
                            id="inactivated"
                            inline
                            value={0}
                            onClick={() => setValue('activated', 0)}
                          />
                        </Col>
                      </Form.Group>
                    </fieldset>
                    <Form.Group as={Row} className="align-items-center">
                      <Form.Label column sm={2} className="text-sm">
                        내용
                      </Form.Label>
                      <Col>
                        <Form.File
                          className="text-sm"
                          onChange={storeImage}
                        />
                        <Form.Text muted>
                          gif, jpg, png 형식의 이미지를 업로드를 할 수 있습니다.
                        </Form.Text>
                        {imageData && (
                          <Form.Text className="mt-2">
                            <span
                              className="text-danger mr-2"
                              style={{ cursor: 'pointer' }}
                              onClick={deleteUploaded}
                            >
                              삭제
                            </span>
                          </Form.Text>
                        )}
                      </Col>
                    </Form.Group>
                  </div>
                  <div className="text-center pt-5">
                    <Button
                      type="button"
                      variant="info"
                      disabled={!imageData}
                      onClick={() => setShowPreview(true)}
                    >
                      미리보기
                    </Button>
                    <Button type="submit" variant="primary" disabled={!imageData}>
                      팝업 추가
                    </Button>
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => {
                        props.history.push('/admin/pages/popup/list');
                      }}
                    >
                      목록으로
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Form>
        <PopUp
          width={getValues('width')}
          height={getValues('height')}
          showPopUp={showPreview}
          setShowPopUp={setShowPreview}
          time={getValues('disable_hours') || 0}
          content={imageData}
        />
      </Container>
    </div>
  );
}

export default withRouter(CreatePopup);
